import dataBloedErnstigVKA from "../../../../src/data/ernstige-bloedingen-onder-vka.json";
import BasicCollapse from "../../../../src/components/chart/interaction/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  dataBloedErnstigVKA,
  BasicCollapse,
  React
};